import { setScreenName } from "../analytics";
import { refreshGame } from "../game";
import store from "../store";
import { gameState, levelDef } from "../game/gameState";
import { refreshProfile } from "../profile";
import { getLogger } from "../logging";

const log = getLogger("Nav");

class Stack {
  constructor() {
    this.reset();
  }

  reset() {
    this._stack = [];
  }

  push(screenName, screenState) {
    setScreenName(screenName);
    this._stack.push({ screenName, screenState });
    log.debug(
      `push ${this.screenName} (stack size ${this._stack.length})`
    );
  }

  pop() {
    const screen = this._stack.pop();
    log.debug(
      `pop ${screen.screenName} (stack size ${this._stack.length})`
    );
    setScreenName(this.screenName);
    updateState(this.screenState);
    return screen;
  }

  updateScreenState(screenState) {
    this._stack[this._stack.length - 1].screenState = screenState;
  }

  get screenName() {
    if (this._stack.length == 0) return null;
    return this._stack[this._stack.length - 1].screenName;
  }

  get screenNamePrev() {
    if (this._stack.length < 2) return null;
    return this._stack[this._stack.length - 2].screenName;
  }

  get screenState() {
    if (this._stack.length == 0) return null;
    return this._stack[this._stack.length - 1].screenState;
  }

  get screenStatePrev() {
    if (this._stack.length < 2) return null;
    return this._stack[this._stack.length - 2].screenState;
  }
}

function updateState(screenState) {
  switch (store.screenName) {
    case "menu":
    case "main_menu":
    case "community_feed":
    case "game":
    case "game_classic":
    case "game_editor":
      break;
    case "profile":
      refreshProfile(screenState.uid);
      break;
    case "game_community":
      {
        const {
          levelDef: levelDefRestored,
          gameState: gameStateRestored,
          gameFrames,
          step,
        } = screenState;
        if (gameFrames) store.gameFrames = gameFrames;
        if (step !== undefined) store.step = step;
        if (levelDefRestored) levelDef.fromOther(levelDefRestored);
        if (gameStateRestored) gameState.fromOther(gameStateRestored);
        refreshGame();
      }
      break;
    default:
      log.warn(`Unexpected screen name: ${store.screenName}`);
    //   throw new Error(`Unexpected screen name: ${store.screenName}`);
  }
}

export const stack = new Stack();

if (__DEV__) window.stack = stack;
